import { styled } from 'baseui';

export const SectionContainer = styled('div', {
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
});
